import type { BlockBase, BlockType, Point } from "./types";

const SIZES: Record<BlockType, { w: number; h: number }> = {
  checklist: { w: 320, h: 300 },
  timer: { w: 300, h: 220 },
  note: { w: 240, h: 240 },
  text: { w: 420, h: 200 },
  card: { w: 340, h: 260 },
  table: { w: 720, h: 380 },
  diagram: { w: 720, h: 480 },
};

export function defaultSizeFor(type: BlockType): { w: number; h: number } {
  return SIZES[type];
}

export function newId(prefix = "b"): string {
  const random = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now().toString(36)}${random}`;
}

export function nextZIndex(blocks: { z: number }[]): number {
  return blocks.reduce((max, block) => Math.max(max, block.z), 0) + 1;
}

function defaultProps(type: BlockType): Record<string, unknown> {
  switch (type) {
    case "checklist":
      return { title: "Checkliste", items: [] };
    case "timer":
      return { mode: "countdown", durationMs: 25 * 60 * 1000, startedAt: null, elapsedMs: 0, label: "Fokus" };
    case "note":
      return { text: "", tone: "yellow" };
    case "text":
      return { text: "", size: "body" };
    case "card":
      return { title: "Karte", text: "", badge: "" };
    case "table":
      return {
        title: "Tabelle",
        columns: [
          { id: "c_name", label: "Aufgabe", type: "text", width: 260 },
          { id: "c_owner", label: "Owner", type: "text", width: 160 },
          { id: "c_done", label: "Fertig", type: "checkbox", width: 100 },
        ],
        rows: [],
        view: { sort: null, filters: [], search: "" },
      };
    case "diagram":
      return { title: "Diagramm", nodes: [], edges: [] };
    default:
      return {};
  }
}

export type NewBlock = BlockBase & { props: Record<string, any> };

export function createBlock(type: BlockType, at: Point, userId: string, z: number): NewBlock {
  const { w, h } = defaultSizeFor(type);
  return {
    id: newId(type.slice(0, 2)),
    type,
    x: Math.round(at.x - w / 2),
    y: Math.round(at.y - h / 2),
    w,
    h,
    z,
    createdBy: userId,
    createdAt: Date.now(),
    props: defaultProps(type),
  };
}
